<template>
  <ProtocolEditComponent
    :local="false"
    :new="false"
    :id="this.$route.params.id"
  />
</template>

<script>
import ProtocolEditComponent from '../../components/protocols/ProtocolEditComponent'
export default {
  name: 'ApiProtocolEdit',
  components: {ProtocolEditComponent}
}
</script>



// WEBPACK FOOTER //
// src/views/api/ProtocolEdit.vue